import { gql } from 'apollo-boost'

const MENU_CRAWLING_JOB = gql`
  query menuCrawlingJob($id: ID!) {
    menuCrawlingJob(id: $id) {
      id
      createdDate
      completedDate
      menuCrawlingResponse {
        id
        data
      }
    }
  }
`

export default MENU_CRAWLING_JOB
